import { style, media } from 'typestyle'
import { important } from 'csx'
export const pr8smi = style(media({ maxWidth: 576 }, { paddingRight: important('8px') }))
